export default {
  verificationPayment: {
    companyConfirmed: "Dieses Unternehmen wurde bereits verifiziert",
    verification: "Verifizierung per Überweisung",
    confirm: "Möchtest du die Firmenautorisierung bestätigen?",
    modal1: {
      title: "Wähle eine Verifizierungsmethode",
      internetTransfer: "Online-Überweisung",
      p24: "Schnelle Online-Zahlung über Przelewy24",
      traditionalTransfer: "Traditionelle Überweisung",
      traditionalInfo: "Verifizierung innerhalb von 24 Stunden nach Zahlungseingang",
      sum: "Die Überweisung sollte in Höhe von 1,00 PLN auf folgende Daten erfolgen.",
      return: "Die Mittel werden innerhalb von 14 Werktagen nach der Verifizierung zurückerstattet.",
    },
    transferInfo: {
      name: "Name des Empfängers",
      nameValue: "ANOTHER INVEST sp. z o.o.",
      address: "Adresse des Empfängers",
      addressValue: "ul. Mikołaja Kopernika 5/LU9 00-367 Warszawa",
      account: "Kontonummer",
      accountValue: "28 1090 2590 0000 0001 4866 7707",
      title: "Verwendungszweck",
      amount: "Betrag",
      titleValue: "Verifizierung der Firmenkonto-ID",
      download: "Formular herunterladen",
    },
  },
};
